import { useState } from 'react';
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle,
  AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction
} from '@/components/ui/alert-dialog';

export function useConfirmDialog() {
  const [state, setState] = useState({ open: false, title: '', description: '', onConfirm: null, variant: 'default' });

  const confirm = ({ title, description, variant = 'default' }) =>
    new Promise((resolve) => {
      setState({ open: true, title, description, variant, onConfirm: () => { setState(s => ({ ...s, open: false })); resolve(true); } });
    });

  const cancel = () => { setState(s => ({ ...s, open: false })); };

  const ConfirmDialogComponent = () => (
    <AlertDialog open={state.open} onOpenChange={(open) => { if (!open) cancel(); }}>
      <AlertDialogContent data-testid="confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>{state.title}</AlertDialogTitle>
          <AlertDialogDescription>{state.description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={cancel} data-testid="confirm-cancel">Annulla</AlertDialogCancel>
          <AlertDialogAction
            onClick={state.onConfirm}
            className={state.variant === 'destructive' ? 'bg-red-600 hover:bg-red-700 text-white' : ''}
            data-testid="confirm-action"
          >
            Conferma
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );

  return { confirm, ConfirmDialog: ConfirmDialogComponent };
}
